import filterPriceBands from './filterPriceBands';
export default filterPriceBands;
